module["exports"] = [
  "Bay",
  "Bayan",
  "Dr.",
  "Prof. Dr."
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/tr/name/prefix.js
 ** module id = 1113
 ** module chunks = 0
 **/